<div class="images-container">
  @for (img of images; track img.path) {
    <div class="available-image"
      (click)="onSelect(img)"
      [ngStyle]="{'background-image': 'url(' + (img.imageDownloadPath | async) + ')'}"
      [ngClass]="isSelected(img) ? 'selected-image' : ''">
      @if (isSelected(img)) {
        <i class="fas fa-check-circle image-selected-icon"></i>
      }
      <button type="button" class="delete-image" title="Delete image"
        [disabled]="deleting.has(img.path)"
        (click)="onDelete(img, $event)">
        <i class="fas fa-trash"></i>
      </button>
    </div>
  }
</div>
